import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

export const ProductLogo: FC = () => {
    return (
        <NavLink to="/" className="layout-header-logo">
            <img src="/logo64.png" alt="Application logo" />
        </NavLink>
    );
};
